<template>
    <div>
        <FormTemplate
            @submit="validate"
        >
            <ContactInformation ref="contactInformation"/>
            <Checkbox
                :error="isSubmit && !agreement"
                v-model="agreement"
            >
                <div v-html="acceptanceText"></div>
            </Checkbox>
            <Checkbox
                v-if="autoPaymentText"
                :error="isSubmit && !autoPayment"
                v-model="autoPayment"
            >
                <div v-html="autoPaymentText"></div>
            </Checkbox>
        </FormTemplate>
    </div>
</template>

<script>
import anticharge from '@/api/anticharge'
import store from '@/store'

import Cookies from 'js-cookie'

import sbg from '@/mixins/sbg'
import comebacker from '@/mixins/comebacker'

import ContactInformation from '@/applications/loan-application/components/contact-information/ContactInformation'
import FormTemplate from '@/templates/form/Form'

import Storage from '@/ext/storage/Storage'

export default {
    name: 'Primary',
    mixins: [
        sbg,
        comebacker,
    ],
    data() {
        return {
            agreement: false,
            autoPayment: false,
            isSubmit: false
        }
    },
    created() {
        this.autoPayment = this.agreement = this.isSbg

        if (this.isAnticharge) {
            alert(`Дата создания: ${this.$store.state.application.createdAt}`)
        }
    },
    mounted() {
        const phoneWatcher = this.$watch('$refs.contactInformation.form.phone', (phone) => {
            if (phone.length === 16 && this.agreement) {
                this.submit(false)
                phoneWatcher()
                agreementWatcher()
            }
        })

        const agreementWatcher = this.$watch('agreement', (agreement) => {
            if (this.$refs.contactInformation.form.phone.length === 16 && agreement) {
                this.submit(false)
                phoneWatcher()
                agreementWatcher()
            }
        })
    },
    computed: {
        isAnticharge() {
            return this.$route.name === 'Anticharge'
        },
        acceptanceText() {
            if (!Cookies.get('sbg-in'))
                return this.$DICTIONARY.acceptanceTextFirst || this.$DICTIONARY.acceptanceText

            return this.$DICTIONARY.acceptanceText
        },
        autoPaymentText() {
            return this.$DICTIONARY.acceptanceAutoPayment
        }
    },
    methods: {
        validate() {
            this.isSubmit = true
            this.$refs.contactInformation.validate();

            ((this.autoPaymentText && this.autoPayment) || !this.autoPaymentText) &&
            this.$refs.contactInformation.isValid && this.agreement && this.submit()
        },
        async submit(send = true) {
            const { checkPhoneByCode, noValid } = await this.$store.dispatch('application/send', {
                contactData: this.$refs.contactInformation.form,
                showLoader: send
            })

            if (noValid && Object.keys(noValid)) {
                const formErrors = this.$refs.contactInformation.formErrors

                formErrors.phone = (noValid.phone === false && 'Невалидное значение') || ''
                formErrors.email = (noValid.email === false && 'Невалидное значение') || ''

                return;
            }

            if (!send)
                return;

            if (!checkPhoneByCode) {
                this.$router.push({ name: 'LoanContact' })
            } else {
                Storage.set('user_phone', this.$refs.contactInformation.form.phone)
                this.$router.push({ name: 'LoanAuth' })
            }
        }
    },
    async beforeRouteEnter(to, from, next) {
        if (to.name === 'Anticharge') {
            await anticharge(to.query)
            await store.dispatch('application/update')
        }

        store.commit('application/load', false)
        next()
    },
    components: {
        ContactInformation,
        FormTemplate,
        Checkbox: () => import('@/components/form/checkbox/Checkbox')
    }
}
</script>